
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontal75 as ObiBatteryHorizontal75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-75.js';
 
 
 

 
 export const ObiBatteryHorizontal75 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-75',
   elementClass: ObiBatteryHorizontal75Element,
   events: {
     
   }
  });
 
 